import React from "react";

export default function TrialPeriodBadge({ subscription }) {
  if (!subscription) return null;

  const label = subscription.badge_label || "Prueba";
  const days = subscription.badge_days ?? subscription.trial_days_remaining ?? 0;

  let tone = "text-white/50 border-white/15 bg-white/[0.03]";
  if (subscription.phase === "active" && subscription.payment_due_soon) {
    tone = "text-amber-300/90 border-amber-500/30 bg-amber-500/10";
  } else if (subscription.phase === "suspended" || days === 0) {
    tone = "text-white/40 border-white/10 bg-white/[0.02]";
  }

  return (
    <span
      className={`hidden sm:inline-flex items-center gap-1.5 text-[11px] px-2.5 py-1 rounded-full border ${tone}`}
      data-testid="trial-period-badge"
      title={`${label} · ${days} día(s) restante(s)`}
    >
      <span className="opacity-70">{label}</span>
      <span className="font-medium">· {days} días</span>
    </span>
  );
}
